module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionarioLocal.nome),
      expression: "funcionarioLocal.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.funcionarioLocal.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.funcionarioLocal, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.nome === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Horário Entrada")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionarioLocal.hr_entrada),
      expression: "funcionarioLocal.hr_entrada"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.funcionarioLocal.hr_entrada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.funcionarioLocal, "hr_entrada", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Horário Saída")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionarioLocal.hr_saida),
      expression: "funcionarioLocal.hr_saida"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.funcionarioLocal.hr_saida)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.funcionarioLocal, "hr_saida", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Inicio Intervalo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionarioLocal.hr_inicio_intervalo),
      expression: "funcionarioLocal.hr_inicio_intervalo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.funcionarioLocal.hr_inicio_intervalo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.funcionarioLocal, "hr_inicio_intervalo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("Fim Intervalo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionarioLocal.hr_fim_intervalo),
      expression: "funcionarioLocal.hr_fim_intervalo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.funcionarioLocal.hr_fim_intervalo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.funcionarioLocal, "hr_fim_intervalo", $event.target.value)
      }
    }
  })])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.servicos,
      "selected-options": _vm.funcionarioLocal.funcao,
      "placeholder": "select item"
    },
    on: {
      "select": _vm.onSelect
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Imagem ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file-input"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "status"
    }
  }, [_vm._v("Please select a file")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.funcionarioLocal.ativo),
      callback: function($$v) {
        _vm.$set(_vm.funcionarioLocal, "ativo", $$v)
      },
      expression: "funcionarioLocal.ativo"
    }
  })], 1)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/colaborador"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar && !_vm.gravando),
      expression: "habilitaGravar && !gravando"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18f2c1c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Funcionarios/novoFuncionario.vue
// module id = 1208
// module chunks = 1